/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {admitStorefrontCheckout} from '../api'

export const useMutationAdmitStorefrontCheckout = createReactQueryMutationHook('admitStorefrontCheckout', admitStorefrontCheckout)
